function watchTextInputs() {
  const inputs = document.querySelectorAll(
    'input[type="text"], input[type="email"], input[type="number"], input[type="password"], input[type="search"], input[type="tel"], select, textarea',
  );
  const events = ['change', 'blur'];

  [...inputs].forEach((input) => {
    events.forEach((event) => {
      input.addEventListener(event, (evt) => {
        input.value.length
          ? input.classList.add('has-value')
          : input.classList.remove('has-value');
      });
    });
  });

  window.addEventListener('clearinput', (evt) => {
    const input = document.getElementById(evt.detail);

    if (input) {
      input.value = '';
      input.classList.remove('has-value');
      input.focus();
    }
  });
}

function handleSelectToggle() {
  const toggles = document.querySelectorAll('[data-js-form-toggle]');

  if (toggles) {
    toggles.forEach((toggle) => {
      const values = toggle.getAttribute('data-js-form-toggle').split(' ');
      const targets = [];
      values.forEach((value) => {
        const fields = document.querySelectorAll(
          `[data-js-form-toggle-target="${value}"]`,
        );
        fields.forEach((field) => {
          targets.push(field);
        });
      });

      toggle.querySelector('select').addEventListener('change', (e) => {
        // Show/hide the target
        const targetValue = `${e.target.id}-${e.target.value}`;

        targets.forEach((target) => {
          target.classList.toggle(
            'u-is-hidden',
            target.getAttribute('data-js-form-toggle-target') !== targetValue,
          );

          // Set keyboard focus to target element
          if (
            target.getAttribute('data-js-form-toggle-target') === targetValue
          ) {
            if (target.querySelector('input')) {
              target.querySelector('input').focus();
            }
            if (target.querySelector('select')) {
              target.querySelector('select').focus();
            }
            if (target.querySelector('textarea')) {
              target.querySelector('textarea').focus();
            }
          }
        });
      });
    });
  }
}

(function ($) {
  /**
   * Form submission tracking for CF7 forms
   *
   * @example Add hidden input to the CF7 form you'd like to track abandonment on
   * `[hidden custom-event-id "GAformTrackingSubmit"]`
   */
  function trackFormSubmissions() {
    const $forms = $('[name="custom-event-id"]').closest('form');

    if (!$forms.length) {
      return;
    }

    $forms.each((i, form) => {
      const $form = $(form);
      const formEventId = $form.find('[name="custom-event-id"]').val();

      $form.on('wpcf7mailsent', () => {
        window.dataLayer.push({
          event: formEventId,
          eventCategory: 'Form Submission',
          formName: formEventId,
        });

        $('html, body').animate(
          {
            scrollTop: $('html, body').offset().top,
          },
          500,
        );
      });
    });
  }

  /**
   * Form abandonment tracking for CF7 forms
   *
   * @example Add hidden input to the CF7 form you'd like to track abandonment on
   * `[hidden abandonment-tracking]`
   */
  class AbandonmentTracking {
    constructor($form) {
      this.$form = $form;
      this.submittedSuccessfully = false;
      this.changed = false;
      this.fieldNamesHistory = [];
      this.formEventId = this.getFormEventId();

      this.handleEvents();
      this.listenToBeforeUnloadEvent();
    }

    /**
     * Returns the form custom-event-id if available, or empty string otherwise.
     */
    getFormEventId() {
      return this.$form.find('[name="custom-event-id"]').attr('value') || '';
    }

    /**
     * Returns the last field name in the field name history array.
     */
    getLastEditedFieldName() {
      return this.fieldNamesHistory[this.fieldNamesHistory.length - 1];
    }

    handleEvents() {
      this.$form.on('input', (e) => {
        const fieldName = $(e.target).attr('name');

        this.changed = true;

        // Only add the field name into the history if it's not the same as the previous field name.
        if (this.getLastEditedFieldName() !== fieldName) {
          this.fieldNamesHistory.push(fieldName);
        }
      });

      this.$form.on('wpcf7submit', () => {
        this.submittedSuccessfully = true;
      });
    }

    addEvent() {
      /**
       * This push an object contains abandonment information to the GA
       *
       * @param eventAction - The name of last edited elements in the form will be passed through here.
       * @param formEventId - The custom event id of the form will be passed through here, if no exisitng one, will pass an empty string ''.
       * @param eventHistory - An array of the name of user interacted form elements will be passed through here, like ['user-first-name', 'user-last-name', 'user-first-name'].
       */
      window.dataLayer &&
        window.dataLayer.push({
          event: 'formAbandonment',
          eventCategory: 'Form Abandonment',
          eventAction: this.getLastEditedFieldName(),
          formEventId: this.formEventId,
          eventHistory: this.fieldNamesHistory,
        });
    }

    listenToBeforeUnloadEvent() {
      window.addEventListener('beforeunload', () => {
        if (this.changed === true && this.submittedSuccessfully === false) {
          this.addEvent();
        }
      });
    }
  }

  function initAbandonmentTracking() {
    const $abandonmentTrackingTriggers = $('[name="abandonment-tracking"]');
    let $forms;

    if ($abandonmentTrackingTriggers.length > 0) {
      $forms = $abandonmentTrackingTriggers.closest('form');

      $forms.each((index, form) => {
        new AbandonmentTracking($(form));
      });
    }
  }

  trackFormSubmissions();
  initAbandonmentTracking();
})(jQuery);

export function init() {
  watchTextInputs();
  handleSelectToggle();
}
